<script>
import { mapActions } from 'vuex';
import { formatSections } from '@/utils/formatData';
import Note from '@/components/shared/Note.vue';
import ApiPageHeader from './Header.vue';
import ApiPageSection from './Section.vue';

export default {
  name: 'ApiPage',

  components: {
    ApiPageHeader,
    ApiPageSection,
    Note,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    sections() {
      return this.content.sections;
    },
  },

  methods: {
    ...mapActions('menu', ['setSectionsMenu', 'clearSectionsMenu']),
  },

  watch: {
    sections() {
      this.clearSectionsMenu();
      this.setSectionsMenu({ sections: formatSections(this.sections) });
    },
  },

  created() {
    this.setSectionsMenu({ sections: formatSections(this.sections) });
  },

  beforeUnmount() {
    this.clearSectionsMenu();
  },
};
</script>

<template>
  <div class="page">
    <div v-if="content.note && content.note.fields" class="note-wrapper">
      <Note :content="content.note.fields" type="large" />
    </div>

    <ApiPageHeader :content="content" />

    <template v-if="content.sections && content.sections.length">
      <ApiPageSection
        v-for="section in content.sections"
        :key="section.sys.id"
        :content="section.fields"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.note-wrapper {
  max-width: $page-width;
  padding-bottom: $space-16;
}

.page {
  padding: $space-24;
  max-width: $page-width;

  @include tablet-small {
    padding: $space-40;
  }
}

@media print {
  .section:first-child {
    break-before: avoid;
  }
}
</style>
